<template>
  <div class="all-lbe">
    <div class="Breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item class="is-l" :to="{ path: '/Home' }">首页</el-breadcrumb-item>
        <!-- <el-breadcrumb-item class="is-l" :to="{ path: '/User' }"
          >个人数据</el-breadcrumb-item
        > -->
        <el-breadcrumb-item :to="{ path: '/User' }">数据</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="total-list">
      <div class="total-list-mm">
        <div class="banner-tittle">
          <div class="user" onload="load_data()">
            <div class="user-img">
              <img class="head-portrait" :src="avatar" alt="" />
              <img class="vip" :src="this.imgUrl" alt="" />
            </div>
            <div class="user-name">
              <span>{{ this.nickName }}</span>
              <div class="motto">{{ this.about }}</div>
            </div>
          </div>
          <div class="user-btn" v-if="letterShow">
            <el-button class="button-r" @click="openClick"> 私信 </el-button>
            <private-message-popover :name="eoistoName" :uuid="messageUuid" :show.sync="show" />
          </div>
        </div>
      </div>
    </div>
    <div class="total-list">
      <div class="user-tabs">
        <el-tabs class="user-data-tabs" v-model="userActiveName" @tab-click="handleUserClick">
          <el-tab-pane label="期货" name="first">
            <div class="accound-list">
              <!-- <div class="account-tittle">帐户</div> -->
              <div class="account-tittle-bac">
                <div class="even-more" style="display: flex" v-show="countInfos !== undefined">
                  <el-radio-group v-model="radioLabel" size="mini" @change="runkChange">
                    <el-radio-button v-for="item in allAccountInfoData.slice(
                      0,
                      allAccountInfoDataIndex
                    )" :key="item.id" :label="item.id" :value="item.id">{{ item.name }}</el-radio-button>
                  </el-radio-group>
                </div>
                <div class="even-more" v-show="countInfos == undefined"
                  style="display: flex; width: 100%; justify-content: center">
                  未绑定交易所
                </div>
                <div class="few-list" v-show="allAccountInfoData.length > 7">
                  <div style="display: none" ref="upRef">
                    <el-button type="primary" @click="upClick">收起 <i class="el-icon-arrow-up"></i></el-button>
                  </div>
                  <div style="display: flex" ref="downRef">
                    <el-button type="primary" @click="downClick">更多<i class="el-icon-arrow-down"></i></el-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="account-profile">
              <div class="account-tittle">帐户概况</div>
              <div class="particulars">
                <div class="particulars-row">
                  <div class="particulars-col">
                    <div class="tittle">帐户资产</div>
                    <div class="price">
                      {{ this.formatNum(this.assetsArr.assets) }}
                    </div>
                  </div>
                  <div class="particulars-col">
                    <div class="tittle">收益率</div>
                    <div class="price" :style="{
                      color: setNumberColor(this.assetsArr.earningScale),
                    }">
                      {{
                        this.assetsArr.earningScale !== 0
                        ? this.formatNum(this.assetsArr.earningScale) + '%'
                        : this.formatNum(this.assetsArr.earningScale) + ''
                      }}
                    </div>
                  </div>
                  <div class="particulars-col">
                    <div class="tittle">累计收益</div>
                    <div class="price">
                      {{ this.formatNum(this.assetsArr.earnings) }}
                    </div>
                  </div>
                  <div class="particulars-col">
                    <div class="tittle">月收益率</div>
                    <!-- <div :class="number > 0 ? 'green' : 'red'"> -->
                    <div class="price" :style="{
                      color: setNumberColor(
                        this.assetsArr.monthEarningsScale
                      ),
                    }">
                      {{
                        this.assetsArr.monthEarningsScale !== 0
                        ? this.formatNum(this.assetsArr.monthEarningsScale) +
                        '%'
                        : this.formatNum(this.assetsArr.monthEarningsScale) +
                        ' '
                      }}
                    </div>
                  </div>
                </div>
                <div class="particulars-row">
                  <div class="particulars-col">
                    <div class="tittle">提现金额</div>
                    <div class="price">
                      {{ this.formatNum(this.assetsArr.cashOut) }}
                    </div>
                  </div>
                  <div class="particulars-col">
                    <div class="tittle">充值金额</div>
                    <div class="price">
                      {{ this.formatNum(this.assetsArr.cashIn) }}
                    </div>
                  </div>
                  <div class="particulars-col">
                    <div class="tittle">胜率</div>
                    <div class="price" :style="{
                      color: setNumberColor(this.assetsArr.winScale),
                    }">
                      {{
                        this.assetsArr.winScale !== 0
                        ? this.formatNum(this.assetsArr.winScale) + '%'
                        : this.formatNum(this.assetsArr.winScale) + ' '
                      }}
                    </div>
                  </div>
                  <div class="particulars-col">
                    <div class="tittle">最大回撤</div>
                    <div class="price" :style="{
                          color: setNumberColor(this.assetsArr.maxRetreat),
                        }">
                      {{
                        this.assetsArr.maxRetreat > 0
                        ? this.formatNum(this.assetsArr.maxRetreat) + '%'
                        : this.formatNum(this.assetsArr.maxRetreat) + ''
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="earnings-chart">
              <div class="earnings-tittle">收益展示</div>
              <div class="earnings-select">
                <el-select v-model="earningValue" style="width: 96px" placeholder="收益" @change="earningChange($event)">
                  <el-option v-for="item in earningOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <el-select style="width: 96px" v-model="timeValue" @change="timeChange($event)" placeholder="时间">
                  <el-option v-for="item in dataOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="charts">
                <!-- <AreaChart ref="earningsChart" /> -->
                <chart class="chart" :option="earningOption" />
              </div>
            </div>
            <div class="account-balance">
              <div class="account-tab">账户资产</div>
              <div class="account-tab">
                <el-tabs v-model="activeName" type="card" @tab-click="handleClick" class="account">
                  <el-tab-pane label="当前持仓情况" name="first">
                    <el-table :data="currentPositionData" border :row-class-name="tableRowClassName"
                      class="current-Position" style="width: 100%" :header-cell-style="{
                        background: 'rgba(66,67,75,1)',
                        color: 'rgba(237, 189, 136, 1)',
                      }">
                      <el-table-column type="index" width="" align="center" v-if="false"></el-table-column>
                      <el-table-column prop="symbol" label="交易标的" align="center">
                        <template slot-scope="scope">{{
                          scope.row.symbol ? scope.row.symbol : '-'
                        }}</template>
                      </el-table-column>
                      <el-table-column prop="side" label="持仓方向" align="center" width="">
                        <template slot-scope="scope">
                          <div :style="{
                              color:
                                scope.row.side == '多'
                                  ? 'rgba(0, 174, 147, 1)'
                                  : 'rgba(247, 82, 95, 1)',
                            }">
                            {{ scope.row.side ? scope.row.side : '-' }}
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column prop="avgPrice" label="持仓均价" sortable align="center" width="">
                        <template slot-scope="scope">{{
                          scope.row.avgPrice
                          ? formatNum(scope.row.avgPrice)
                          : '-'
                        }}</template>
                      </el-table-column>
                      <el-table-column prop="positionAmt" label="仓位数量" width="" align="center">
                        <template slot-scope="scope">{{
                          scope.row.symbol.substring(
                            scope.row.symbol.length - 4
                          ) == 'USDT'
                          ? scope.row.positionAmt + '个'
                          : scope.row.positionAmt + '张'
                        }}</template>
                      </el-table-column>
                      <el-table-column prop="maxNotional" label="名义价值(USD）" width="150" align="center">
                        <template slot-scope="scope">{{
                          scope.row.maxNotional
                          ? formatNum(scope.row.maxNotional)
                          : '-'
                        }}</template>
                      </el-table-column>
                      <el-table-column prop="bustPrice" label="爆仓价格" width="" align="center">
                        <template slot-scope="scope">{{
                          scope.row.bustPrice
                          ? formatNum(scope.row.bustPrice)
                          : '-'
                        }}</template>
                      </el-table-column>
                      <el-table-column prop="leverage" label="名义杠杆" width="" align="center">
                        <template slot-scope="scope">{{
                          scope.row.leverage ? scope.row.leverage : '-'
                        }}</template>
                      </el-table-column>
                      <!-- <el-table-column
                        prop="cumRealisedPnl"
                        label="已结盈亏"
                        width=""
                        align="center"
                      >
                        <template slot-scope="scope">
                          <div
                            :style="{
                              color:
                                scope.row.cumRealisedPnl > 0
                                  ? 'rgba(0, 174, 147, 1)'
                                  : scope.row.cumRealisedPnl == 0
                                  ? 'rgba(209, 212, 220, 1)'
                                  : 'rgba(247, 82, 95, 1)',
                            }"
                          >
                            {{
                              scope.row.cumRealisedPnl
                                ? formatNum(scope.row.cumRealisedPnl)
                                : '-'
                            }}
                          </div></template
                        >
                      </el-table-column> -->
                      <el-table-column prop="unrealisedPnl" label="未结盈亏" width="" align="center">
                        <template slot-scope="scope">{{
                          scope.row.unrealisedPnl
                          ? formatNum(scope.row.unrealisedPnl)
                          : '-'
                        }}</template>
                      </el-table-column>
                    </el-table>
                  </el-tab-pane>
                  <el-tab-pane label="挂单情况" name="second">
                    <el-table :data="entryOrdersData" border class="current-Position" :row-class-name="tableRowClassName"
                      style="width: 100%" :header-cell-style="{
                        background: 'rgba(64,66,73,1)',
                        color: 'rgba(237, 189, 136, 1)',
                      }">
                      <el-table-column type="index" width="" align="center" v-if="false"></el-table-column>
                      <el-table-column prop="symbol" label="标的名称" align="center" width="">
                        <template slot-scope="scope">{{
                          scope.row.symbol ? scope.row.symbol : '-'
                        }}</template>
                      </el-table-column>

                      <el-table-column prop="origQty" label="委托数量" align="center" width="">
                        <template slot-scope="scope">
                          {{ scope.row.origQty ? scope.row.origQty : '-' }}
                        </template>
                      </el-table-column>
                      <el-table-column prop="origType" label="订单类型" align="center" width="">
                        <template slot-scope="scope">{{
                          scope.row.origType ? scope.row.origType : '-'
                        }}</template>
                      </el-table-column>
                      <el-table-column prop="price" label="委托价格" align="center" width="">
                        <template slot-scope="scope">{{
                          scope.row.price ? formatNum(scope.row.price) : '-'
                        }}</template>
                      </el-table-column>

                      <el-table-column prop="side" label="方向" width="" align="center">
                        <template slot-scope="scope">
                          <div :style="{
                              color:
                                scope.row.side == '平仓买入' ||
                                  scope.row.side == '开仓买入'
                                  ? 'rgba(0, 174, 147, 1)'
                                  : 'rgba(247, 82, 95, 1)',
                            }">
                            {{ scope.row.side ? scope.row.side : '-' }}
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column prop="stopPrice" label="触发价" align="center" width="">
                        <template slot-scope="scope">{{
                          scope.row.stopPrice ? scope.row.stopPrice : '-'
                        }}</template>
                      </el-table-column>
                      <el-table-column prop="time" label="订单时间" sortable width="" align="center">
                        <template slot-scope="scope">{{
                          scope.row.time ? scope.row.time : '-'
                        }}</template>
                      </el-table-column>
                    </el-table>
                  </el-tab-pane>
                  <el-tab-pane label="历史记录" name="third">
                    <el-table :data="historyData" border class="current-Position" :row-class-name="tableRowClassName"
                      style="width: 100%" :header-cell-style="{
                        background: 'rgba(64,66,73,1)',
                        color: 'rgba(237, 189, 136, 1)',
                      }">
                      <el-table-column type="index" width="" align="center" v-if="false"></el-table-column>
                      <el-table-column prop="symbol" label="交易标的" align="center" width="100">
                        <template slot-scope="scope">{{
                          scope.row.symbol ? scope.row.symbol : '-'
                        }}</template>
                      </el-table-column>
                      <el-table-column prop="orderPrice" label="持仓方向" align="center">
                        <template slot-scope="scope">
                          <div :style="{
                              color:
                                scope.row.side == '多'
                                  ? 'rgba(0, 174, 147, 1)'
                                  : scope.row.cumRealisedPnl == null
                                    ? 'rgba(209, 212, 220, 1)'
                                    : 'rgba(247, 82, 95, 1)',
                            }">
                            {{ scope.row.side ? scope.row.side : '-' }}
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column prop="qty" label="委托数量" width="" align="center">
                        <template slot-scope="scope">{{
                          scope.row.qty ? scope.row.qty : '-'
                        }}</template>
                      </el-table-column>
                      <el-table-column prop="avgEntryPrice" label="平均入场价格" width="" align="center">
                        <template slot-scope="scope">{{
                          scope.row.avgEntryPrice
                          ? formatNum(scope.row.avgEntryPrice)
                          : '-'
                        }}</template>
                      </el-table-column>
                      <el-table-column prop="avgExitPrice" label="平均出场价格" align="center">
                        <template slot-scope="scope">{{
                          scope.row.avgExitPrice
                          ? formatNum(scope.row.avgExitPrice)
                          : '-'
                        }}</template>
                      </el-table-column>
                      <el-table-column prop="closedSize" label="仓位大小" align="center">
                        <template slot-scope="scope">{{
                          scope.row.closedSize ? scope.row.closedSize : '-'
                        }}</template>
                      </el-table-column>
                      <el-table-column prop="realizedPnl" label="实现盈亏" align="center">
                        <template slot-scope="scope">
                          <div :style="{
                              color:
                                scope.row.realizedPnl > 0
                                  ? 'rgba(0, 174, 147, 1)'
                                  : scope.row.realizedPnl == 0
                                    ? 'rgba(209, 212, 220, 1)'
                                    : 'rgba(247, 82, 95, 1)',
                            }">
                            {{
                              scope.row.realizedPnl
                              ? formatNum(scope.row.realizedPnl)
                              : '-'
                            }}
                          </div>
                        </template>
                      </el-table-column>

                      <el-table-column prop="leverage" label="杠杆倍数" align="center">
                        <template slot-scope="scope">{{
                          scope.row.leverage ? scope.row.leverage : '-'
                        }}</template>
                      </el-table-column>
                      <el-table-column prop="time" label="时间" sortable width="160" align="center">
                        <template slot-scope="scope">{{
                          scope.row.time ? scope.row.time : '-'
                        }}</template>
                      </el-table-column>
                    </el-table>
                  </el-tab-pane>
                </el-tabs>
              </div>
              <div class="pagination">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                  :current-page.sync="pageParams.currentPage" background layout="sizes,prev, pager, next"
                  :total="pageParams.total" :page-count="pageParams.pageCount" :page-sizes="[5, 10, 20, 50, 100]"
                  :page-size="pageParams.pageSize">
                </el-pagination>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="期权" name="second">
            <individual-option v-if="optionShow" />
          </el-tab-pane>
          <el-tab-pane label="现货" name="third"><personal-spot v-if="spotShow" /></el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getUserAsset,
  getPersonalEarning,
  getPersonalPosition,
  getPersonalOrder,
  getPersonalHistory,
} from '../api/User';
import AreaChart from '../echarts/AreaChart.vue';
import Chart from '../echarts/chart.vue';
import PrivateMessagePopover from '../components/popover/PrivateMessagePopover.vue';
import IndividualOption from '../components/individualOption/IndividualOption.vue';
import PersonalSpot from '../components/spotGoods/personalSpot.vue';
export default {
  name: 'User',
  components: {
    AreaChart,
    Chart,
    PrivateMessagePopover,
    IndividualOption,
    PersonalSpot,
  },
  data() {
    return {
      letterShow: false,
      eoistoName: '',
      messageUuid: '',
      show: false,
      userActiveName: 'first',
      optionShow: false,
      spotShow: false,
      earningOptions: [
        {
          value: 'assets',
          label: '资产',
        },
        {
          value: 'earning',
          label: '收益',
        },
        {
          value: 'earningScale',
          label: '收益率',
        },
      ],

      dataOptions: [
        {
          value: 'day',
          label: '一天',
        },
        {
          value: 'week',
          label: '七天',
        },
        {
          value: 'month',
          label: '30天',
        },
        {
          value: 'all',
          label: '全部',
        },
      ],
      countInfos: [],
      earningValue: 'assets',
      timeValue: 'all',
      earningXData: [],
      earningYData: [],
      activeName: 'first',
      //当前持仓情况
      currentPositionData: [],
      //挂单情况
      entryOrdersData: [],
      //历史记录
      historyData: [],
      earningOption: {
        title: {
          text: '',
        },
      },
      num: '1234.56',
      number: '-1234.56',
      targetUUID: '',
      nickName: '',
      vipName: '',
      avatar: '',
      about: '',
      imgUrl: '',

      myNickName: '',
      myVipName: '',
      myAvatar: '',
      myAbout: '',
      myImgUrl: '',

      assetsArr: {
        assets: '',
        earningScale: '',
        earnings: '',
        monthEarningsScale: '',
        cashOut: '',
        cashIn: '',
        winScale: '',
        maxRetreat: '',
      },
      pageParams: {
        pageIndex: 1,
        pageSize: 10,
        pageCount: 1,
      },
      activeNames: '',
      allTittle: '更多',
      accountId: '',
      allAccountInfoData: [
        {
          id: '',
          name: '',
        },
      ],
      radio: '',
      allAccountInfoDataIndex: 0,
      radioLabel: '',
    };
  },
  mounted() {
    this.load_data();
    this.eoistoName = this.$route.query.userName;
    this.messageUuid = this.$route.query.targetUUID;
  },
  async created() {
    await this.assetData('create');
    await this.findUserBenefitsData();
    await this.findAssetsById();
    // await this.findOrderData();
    // await this.findHistroyData();
    this.findProfitForm();
  },
  methods: {
    openClick() {
      this.show = true;
    },
    handleUserClick(tab) {
      if (tab.label == '期权') {
        this.optionShow = true;
        this.spotShow = false;
      } else if (tab.label == '现货') {
        this.optionShow = false;
        this.spotShow = true;
      } else if (tab.label == '期货') {
        this.radioLabel = this.allAccountInfoData[0].id;
        this.runkChange(this.radioLabel);
        this.optionShow = false;
        this.spotShow = false;
      }
    },
    //页面刚加载的时候，开始判断，如果有用户名，就显示在页面上，如果没有用户名的话，就显示登录名称
    async load_data() {
      var theme = localStorage.getItem('token');
      this.allAccountInfoData = this.$store.state.apiNameArr;
      if (this.allAccountInfoData.length == 0) {
        this.accountRadio = '';
        this.accoundFalse = false;
      } else {
        // 显示用户信息
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        this.myNickName = userInfo.nickname;
        this.myVipName = userInfo.vipName;
        this.myAvatar = userInfo.avatar;
        this.myAbout = userInfo.about;
        var text = this.myVipName;

        const uuid = this.$route.query.targetUUID;

        this.radio = uuid ? '' : this.allAccountInfoData[0].id;
        if (this.radio == '') {
          this.letterShow = true;
        } else {
          this.letterShow = false;
        }
        this.radioLabel = this.allAccountInfoData[0].id;
        const currentInfo = this.$route.query.userName
        let infoIndex = 7

        if (currentInfo) {
          infoIndex = (userInfo.nickname === currentInfo ? userInfo.nickname : currentInfo).length
        } else {
          infoIndex = userInfo.nickname.lenght
        }


        //console.log("账户显示长度判断", userInfo.nickname, currentInfo, infoIndex)
        //账户显示长度判断
        this.allAccountInfoDataIndex =
          infoIndex > 7
            ? 7
            : infoIndex;
      }






      //根据名字获取相应的图片

      if (text == null) {
        this.myImgUrl = '';
      } else {
        switch (text) {
          case 'A1':
            this.myImgUrl = require('@/assets/img/rtaLogo/A1.svg');
            break;
          case 'A2':
            this.myImgUrl = require('@/assets/img/rtaLogo/A2.svg');
            break;
          case 'A3':
            this.myImgUrl = require('@/assets/img/rtaLogo/A3.svg');
            break;
          case 'A4':
            this.myImgUrl = require('@/assets/img/rtaLogo/A4.svg');
            break;
          case 'A5':
            this.myImgUrl = require('@/assets/img/rtaLogo/A5.svg');
            break;
          case 'A6':
            this.myImgUrl = require('@/assets/img/rtaLogo/A6.svg');
            break;
          case 'A7':
            this.myImgUrl = require('@/assets/img/rtaLogo/A7.svg');
            break;
          case 'A8':
            this.myImgUrl = require('@/assets/img/rtaLogo/A8.svg');
            break;
          case 'A9':
            this.myImgUrl = require('@/assets/img/rtaLogo/A9.svg');
            break;
        }
      }
    },
    //账户筛选
    runkChange(value) {
      this.radio = value;
      this.assetData();
      this.earningValue = 'assets';
      this.timeValue = 'all';
      this.findUserBenefitsData();
      // this.findAssetsById();
      this.handleClick();
    },
    handleChange(val) { },
    //获取账户情况所有数据
    async assetData(staus = '') {
      let params = {
        targetUUID: this.$route.query.targetUUID,
        accountId: this.radio,
      };
      const { data: res } = await getUserAsset(params);
      this.countInfos = res.data;
      let userres = [];
      if (res.code == 0) {
        userres = res.data.user;
        this.$store.commit('changeNewApiValue', this.allAccountInfoData);
        this.allAccountInfoData = res.data.account.allAccountInfo;

        if (typeof this.$route.query.targetUUID == 'string') {
          if (staus == 'create')
            this.radioLabel = res.data.account.allAccountInfo[0].id;
        }

        let assets = res.data;
        this.assetsArr.assets = assets.assets;
        this.assetsArr.earningScale = assets.earningScale;
        this.assetsArr.earnings = assets.earnings;
        this.assetsArr.monthEarningsScale = assets.monthEarningsScale;
        this.assetsArr.cashOut = assets.cashOut;
        this.assetsArr.cashIn = assets.cashIn;
        this.assetsArr.winScale = assets.winScale;
        this.assetsArr.maxRetreat = assets.maxRetreat;

        this.nickName = assets.user.userName;
        this.vipName = assets.user.vipName;
        this.avatar = assets.user.avatar;
        this.about = assets.user.about;
        var text = this.vipName;
        //根据名字获取相应的图片;

        if (text == null) {
          this.imgUrl = '';
        } else {
          switch (text) {
            case 'A1':
              this.imgUrl = require('@/assets/img/rtaLogo/A1.svg');
              break;
            case 'A2':
              this.imgUrl = require('@/assets/img/rtaLogo/A2.svg');
              break;
            case 'A3':
              this.imgUrl = require('@/assets/img/rtaLogo/A3.svg');
              break;
            case 'A4':
              this.imgUrl = require('@/assets/img/rtaLogo/A4.svg');
              break;
            case 'A5':
              this.imgUrl = require('@/assets/img/rtaLogo/A5.svg');
              break;
            case 'A6':
              this.imgUrl = require('@/assets/img/rtaLogo/A6.svg');
              break;
            case 'A7':
              this.imgUrl = require('@/assets/img/rtaLogo/A7.svg');
              break;
            case 'A8':
              this.imgUrl = require('@/assets/img/rtaLogo/A8.svg');
              break;
            case 'A9':
              this.imgUrl = require('@/assets/img/rtaLogo/A9.svg');
              break;
          }
        }
      } else {
        this.assetsArr.assets = 0;
        this.assetsArr.earningScale = 0;
        this.assetsArr.earnings = 0;
        this.assetsArr.monthEarningsScale = 0;
        this.assetsArr.cashOut = 0;
        this.assetsArr.cashIn = 0;
        this.assetsArr.winScale = 0;
        this.assetsArr.maxRetreat = 0;

        this.nickName = this.myNickName;
        this.vipName = this.myVipName;
        this.avatar = this.myAvatar;
        this.about = this.myAbout;
        this.imgUrl = this.myImgUrl;
      }
    },
    upClick() {
      this.allAccountInfoDataIndex = 7;
      this.$refs.upRef.style.display = 'none';
      this.$refs.downRef.style.display = 'flex';
    },
    downClick() {
      this.allAccountInfoDataIndex = this.allAccountInfoData.length;
      this.$refs.upRef.style.display = 'flex';
      this.$refs.downRef.style.display = 'none';
    },
    //收益筛选
    earningChange(item) {
      this.earningValue = item;
      this.findUserBenefitsData();
    },
    //账户概括时间筛选
    timeChange(item) {
      this.timeValue = item;
      //console.log(item);
      this.findUserBenefitsData();
    },
    //获取用户收益所有数据
    async findUserBenefitsData(id) {
      let params = {
        targetUUID: this.$route.query.targetUUID,
        accountId: this.radio,
        queryType: this.earningValue,
        queryTime: this.timeValue,
      };
      const { data: res } = await getPersonalEarning(params);

      //console.log('收益', res);
      if (res.code == 0) {
        let allData = [...res.data];
        this.earningXData = allData.map((v) => v.time);
        this.xData = [];
        this.earningYData = allData.map((v) => v.data);
        this.findProfitForm(this.earningValue);
      } else if (res.code == 10001) {
        // this.$message.error('请求时间暂无数据!');

        this.earningXData = [];
        this.earningYData = [];
        this.findProfitForm(this.earningValue);
        //console.log(this.earningXData, this.earningYData);
      }
    },
    //千分位处理
    formatNum(strNum) {
      if (strNum.length <= 3) {
        return strNum;
      }
      if (!/^(\+|-)?(\d+)(\.\d+)?$/.test(strNum)) {
        return strNum;
      }
      var a = RegExp.$1,
        b = RegExp.$2,
        c = RegExp.$3;
      var re = new RegExp();
      re.compile('(\\d)(\\d{3})(,|$)');
      while (re.test(b)) {
        b = b.replace(re, '$1,$2$3');
      }
      return a + '' + b + '' + c;
    },
    //数据显示设置不同颜色
    setNumberColor(num) {
      let a = num;
      if (a < 0) {
        return 'rgba(247, 82, 95, 1)';
      }
      if (a > 0) {
        return 'rgba(0, 174, 147, 1)';
      }

      if ((a = 0)) {
        return '#fffff';
      }
    },
    //账户资产标签切换事件
    handleClick() {
      this.currentPositionData = [];
      this.entryOrdersData = [];
      this.historyData = [];
      this.pageParams.pageIndex = 1;
      this.pageParams.pageSize = 10;
      if (this.activeName == 'second') {
        this.findOrderData();
      } else if (this.activeName == 'third') {
        this.findHistroyData();
      } else {
        this.findAssetsById();
      }
    },
    //奇偶行背景色不同
    tableRowClassName({ rowIndex }) {
      if ((rowIndex + 1) % 2 === 0) {
        return 'oddRow';
      }

      return 'evenRow';
    },
    // 收益展示
    findProfitForm() {
      let queryType = this.earningValue;
      const xData = this.earningXData;
      const yData = this.earningYData;
      if (xData.length == 0) {
        //暂无数据
        this.earningOption = {
          title: {
            text: '暂无数据',
            x: 'center',
            y: 'center',
            textStyle: {
              fontSize: 16,
              fontWeight: 'normal',
              color: 'rgba(209, 212, 220, 1)', //设置文字颜色
            },
          },
          xAxis: {
            data: [],
          },
          series: [
            {
              data: [],
            },
          ],
        };
      } else {
        this.earningOption = {
          title: {
            text: '',
          },
          color: 'rgba(0, 174, 147, 1)',
          tooltip: {
            trigger: 'axis',
            borderWidth: '0', //边框宽度设置1
            borderColor: 'none', //设置边框颜色
            formatter: (params, i) => {
              i = queryType;
              let result = `${params[0].name}<br>`;
              if (i == 'assets') {
                params.forEach((item) => {
                  var aaa = this.kmb(item.value);
                  result += `资产 : <span style="color:rgba(0, 174, 147, 1);padding-left:5px;font-size:16px;">$${aaa}</br>`;
                });
                return result;
              }
              if (i == 'earning') {
                params.forEach((item) => {
                  var aaa = this.kmb(item.value);
                  result += `收益 : <span style="color:rgba(0, 174, 147, 1);padding-left:5px;font-size:16px;">$${aaa}</br>`;
                });
                return result;
              } else if (i == 'earningScale') {
                params.forEach((item) => {
                  if (item.value < 0) {
                    result += `收益率 : <span style="color:rgba(247, 82, 95, 1);padding-left:5px;font-size:16px;">${this.formatNum(
                      item.value
                    )}%</br>`;
                  } else {
                    result += `收益率 : <span style="color:rgba(0, 174, 147, 1);padding-left:5px;font-size:16px;">${this.formatNum(
                      item.value
                    )}%</br>`;
                  }
                });
                return result;
              }
            },
            padding: 20,
            textStyle: {
              color: 'rgba(209, 212, 220, 1)', //设置文字颜色
              fontSize: '16',
            },
            extraCssText: 'background:rgba(61, 63, 71, 1);',
          },
          grid: {
            top: '5%',
            left: '0%',
            right: '3%',
            bottom: '3%',
            containLabel: true,
          },

          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: xData,
            offset: 12,
            axisLabel: {
              textStyle: {
                color: 'rgba(209, 212, 220, 1)',
              },
            },
          },
          yAxis: {
            type: 'value',
            splitLine: {
              lineStyle: {
                // 使用深浅的间隔色
                color: ['rgba(159, 159, 159, 0.1)'],
              },
            },
            axisLabel: {
              formatter: function (v, i) {
                i = queryType;
                if (i == 'earningScale') {
                  return v + '%';
                } else {
                  if (v > 1000 && v <= 1000000) {
                    return v / 1000 + 'K';
                  } else if (v > 1000000 && v <= 1000000000) {
                    return v / 1000000 + 'M';
                  } else if (v > 1000000000) {
                    return v / 1000000000 + 'B';
                  } else {
                    return v;
                  }
                }
              },
              textStyle: {
                color: 'rgba(209, 212, 220, 1)',
              },
              margin: 20,
            },
          },
          series: [
            {
              name: '资产',
              data: this.formatNum(yData),
              type: 'line',
              symbol: 'cricle',
              showSymbol: false,
              // lineStyle: {},
              // areaStyle: {}, //区域背景色
              lineStyle: {
                color: 'rgba(0, 174, 147, 1)',
              },
              itemStyle: {
                color: 'rgba(0, 174, 147, 1)',
              },

              areaStyle: {
                normal: {
                  color: {
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0.1,
                        color: 'rgba(0, 174, 147, 0.2000)', // 0% 处的颜色
                      },
                      {
                        offset: 0.9,
                        color: 'rgba(0, 174, 147, 0)', // 100% 处的颜色
                      },
                    ],
                    globalCoord: false, // 缺省为 false
                  },
                },
              },
            },
          ],
        };
      }
    },
    // 每页显示的记录数切换事件
    handleSizeChange(val) {
      this.pageParams.pageSize = val;
      this.currentPositionData = [];
      this.entryOrdersData = [];
      this.historyData = [];
      if (this.activeName == 'second') {
        this.findOrderData();
      } else if (this.activeName == 'third') {
        this.findHistroyData();
      } else {
        this.findAssetsById();
      }
    },
    // 切换页码事件
    handleCurrentChange(val) {
      this.pageParams.pageIndex = val;
      this.currentPositionData = [];
      this.entryOrdersData = [];
      this.historyData = [];
      if (this.activeName == 'second') {
        this.findOrderData();
      } else if (this.activeName == 'third') {
        this.findHistroyData();
      } else {
        this.findAssetsById();
      }
    },
    formatDate(time) {
      if (time != null) {
        var datetime = new Date();
        datetime.setTime(time);
        var year = datetime.getFullYear();
        var month =
          datetime.getMonth() + 1 < 10
            ? '0' + (datetime.getMonth() + 1)
            : datetime.getMonth() + 1;
        var date =
          datetime.getDate() < 10
            ? '0' + datetime.getDate()
            : datetime.getDate();
        var hour =
          datetime.getHours() < 10
            ? '0' + datetime.getHours()
            : datetime.getHours();
        var minute =
          datetime.getMinutes() < 10
            ? '0' + datetime.getMinutes()
            : datetime.getMinutes();
        var second =
          datetime.getSeconds() < 10
            ? '0' + datetime.getSeconds()
            : datetime.getSeconds();
        return (
          year +
          '-' +
          month +
          '-' +
          date +
          ' ' +
          hour +
          ':' +
          minute +
          ':' +
          second
        ); //返回 YYYY-MM-DD HH:MM:SS
        //return year + '-' + month + '-' + date; //返回 YYYY-MM-DD
      } else {
        return '---';
      }
    },

    // 获取一个账户下的所有当前持仓情况数据
    async findAssetsById() {
      let params = {
        targetUUID: this.$route.query.targetUUID,
        accountId: this.radio,
        pageIndex: this.pageParams.pageIndex,
        pageSize: this.pageParams.pageSize,
      };
      const { data: res } = await getPersonalPosition(params);
      if (res.code == 0) {
        let positions = res.data;

        this.pageParams.pageCount = res.pageCount;
        positions.forEach((item) => {
          this.timeArr = this.formatDate(new Date(item.createTime));
          const positionObj = {
            symbol: item.symbol,
            side: item.side,
            avgPrice: item.avgPrice,
            positionAmt: item.positionAmt,
            maxNotional: item.maxNotional,
            bustPrice: item.bustPrice,
            leverage: item.leverage,
            cumRealisedPnl: item.cumRealisedPnl,
            unrealisedPnl: item.unrealisedPnl,
          };
          if (positionObj.isolated == true) {
            positionObj.isolated = '是';
          } else {
            positionObj.isolated = '否';
          }
          this.currentPositionData.push(positionObj);
        });
      }
    },
    //获取挂单情况所有数据
    async findOrderData() {
      let params = {
        accountId: this.radio,
        targetUUID: this.$route.query.targetUUID,
        pageIndex: this.pageParams.pageIndex,
        pageSize: this.pageParams.pageSize,
      };
      const { data: res } = await getPersonalOrder(params);
      if (res.code == 0) {
        let orders = res.data;
        this.pageParams.pageCount = res.pageCount;
        orders.forEach((item) => {
          this.timeArr = this.formatDate(new Date(item.time));
          const ordersObj = {
            symbol: item.symbol,
            origQty: item.origQty,
            origType: item.origType,
            price: item.price,
            side: item.side,
            stopPrice: item.stopPrice,
            time: this.timeArr,
          };
          this.entryOrdersData.push(ordersObj);
        });
      }
    },
    //获取历史记录所有数据
    async findHistroyData() {
      // this.pageParams.pageCount = 0;
      let params = {
        accountId: this.radio,
        targetUUID: this.$route.query.targetUUID,
        pageIndex: this.pageParams.pageIndex,
        pageSize: this.pageParams.pageSize,
      };
      const { data: res } = await getPersonalHistory(params);
      if (res.code == 0) {
        let histroys = res.data;
        this.pageParams.pageCount = res.pageCount;
        histroys.forEach((item) => {
          this.timeArr = this.formatDate(new Date(item.time));
          const histroysObj = {
            symbol: item.symbol,
            orderId: item.orderId,
            orderPrice: item.orderPrice,
            side: item.side,
            qty: item.qty,
            avgEntryPrice: item.avgEntryPrice,
            avgExitPrice: item.avgExitPrice,
            closedSize: item.closedSize,
            realizedPnl: item.realizedPnl,
            leverage: item.leverage,
            time: this.timeArr,
          };
          this.historyData.push(histroysObj);
        });
      }
    },
  },
};
</script>
<style lang="scss">
.oddRow {
  //斑马纹样式

  color: white;

  background-color: rgba(102, 102, 102, 0.1) !important;

  .el-table__cell {
    padding: 0 !important;
    margin: 0 !important;

    .cell {
      font-size: 14px;
      font-family: Roboto-Regular, Roboto;
      font-weight: 400;
      color: #d1d4dc;
    }
  }
}

.evenRow {
  background-color: rgba(255, 255, 255, 0.1) !important;

  color: white;

  .el-table__cell {
    padding: 0 !important;
    margin: 0 !important;

    .cell {
      font-size: 14px;
      font-family: Roboto-Regular, Roboto;
      font-weight: 400;
      color: #d1d4dc;
    }
  }
}
</style>
<style lang="scss" scope >
.all-lbe {
  width: 1200px;
  height: 100%;
  //text-align: center;
  margin: 40px auto !important;
  display: flex;
  flex-direction: column;

  .Breadcrumb {
    .el-breadcrumb {
      .el-breadcrumb__item {
        .el-breadcrumb__inner {
          color: rgba(209, 212, 220, 1);
          font-size: 14px;
          font-family: MicrosoftYaHei;
          line-height: 22px;
        }

        .el-breadcrumb__separator {
          font-size: 10px;
        }
      }

      .is-l {
        span {
          color: rgba(140, 140, 140, 1) !important;
        }
      }
    }
  }

  .total-list {
    width: 100%;
    height: 100%;
    background: rgba(159, 159, 159, 0.1);
    margin-top: 40px;
    border-radius: 8px;

    .user-tabs {
      .user-data-tabs {
        .el-tabs__header {
          padding: 24px 20px 0;
          margin: 0 !important;

          .el-tabs__nav-wrap {
            .el-tabs__nav-scroll {
              border-bottom: 1px solid rgba(0, 0, 0, 0.1);

              .el-tabs__nav {
                .el-tabs__active-bar {
                  background-color: #edbd88;
                  height: 4px;
                }

                .el-tabs__item.is-active {
                  font-size: 18px;
                  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                  font-weight: bold;
                  color: #edbd88;
                }

                .el-tabs__item {
                  font-size: 16px;
                  font-family: MicrosoftYaHei;
                  color: #d1d4dc;
                  margin-bottom: 12px;
                  padding: 0 20px 0 0 !important;
                }
              }
            }
          }

          .el-tabs__nav-wrap::after {
            display: none !important;
          }
        }

        .el-tabs__content {
          margin: 0 20px 60px;

          .el-tab-pane {
            .accound-list {
              margin: 32px 0 0 0;

              .account-tittle {
                font-size: 16px;
                font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                font-weight: 400;
                color: #d1d4dc;
                line-height: 21px;
              }

              .account-tittle-bac {
                // margin-top: 20px;
                // width: 100%;
                // background: rgba(255, 255, 255, 0.1);
                border-radius: 4px;
                // padding: 16px;
                display: flex;
                justify-content: space-between;

                .even-more {
                  width: 900px;

                  .el-radio-group {
                    .el-radio-button {
                      width: 120px;
                      height: 40px;
                      padding: 0 !important;

                      margin: 0 4px 4px 0;

                      .el-radio-button__inner {
                        border-radius: 2px;
                        margin: 0;
                        padding: 0;
                        width: 120px;
                        height: 40px;
                        line-height: 40px;
                        background: transparent;
                        font-size: 14px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #d1d4dc;
                        border: 1px solid rgba(151, 151, 151, 0.5);
                      }

                      .el-radio-button__inner:focus {
                        background: rgba(237, 189, 136, 1) !important;
                        color: #33353e;
                        border: none;
                      }

                      .el-radio-button__inner:hover {
                        background: transparent;
                        color: #edbd88;
                        border: 1px solid #edbd88;
                        border-radius: 2px;
                      }

                      .el-radio-button__orig-radio:checked+.el-radio-button__inner {
                        background: rgba(237, 189, 136, 1);
                        color: #33353e;
                      }

                      .el-radio-button__orig-radio:checked+.el-radio-button__inner {
                        border-color: none;
                        -webkit-box-shadow: none;
                        box-shadow: none;
                      }
                    }
                  }
                }

                .few-list {
                  height: 40px;

                  .el-button {
                    margin: 0;
                    padding: 0;
                    width: 74px;
                    height: 32px;
                    border-radius: 4px;
                    border: 1px solid rgba(209, 212, 220, 0.5);
                    background: transparent;

                    span {
                      font-size: 14px;
                      font-family: MicrosoftYaHei;
                      color: rgba(209, 212, 220, 1);
                    }
                  }
                }
              }
            }

            .account-profile {
              margin-top: 32px;

              .account-tittle {
                font-size: 16px;
                font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                font-weight: 400;
                color: #d1d4dc;
                line-height: 21px;
              }

              .particulars {
                .particulars-row {
                  margin-top: 20px;
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;

                  .particulars-col {
                    width: 265px !important;
                    height: 100px;
                    background: rgba(65, 67, 75, 1);
                    border-radius: 4px;

                    .tittle {
                      margin: 20px 0 0 24px;
                      font-size: 13px;
                      font-family: MicrosoftYaHei;
                      color: #d1d4dc;
                      line-height: 17px;
                    }

                    .price {
                      margin: 0px 0 0 24px;
                      font-size: 24px;
                      font-family: DIN-Medium;
                      font-weight: 400;
                      //color: #d1d4dc;
                      line-height: 42px;
                    }

                    .green {
                      margin: 0px 0 0 32px;
                      font-size: 36px;
                      font-family: DIN-Medium;
                      font-weight: 400;
                      line-height: 42px;
                      // color: rgba(0, 174, 147, 1);
                    }

                    .red {
                      margin: 0px 0 0 32px;
                      font-size: 36px;
                      font-family: DIN-Medium;
                      font-weight: 400;
                      line-height: 42px;
                      //color: rgba(247, 82, 95, 1);
                    }
                  }
                }
              }
            }

            .earnings-chart {
              margin-top: 32px;

              .earnings-tittle {
                font-size: 16px;
                font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                font-weight: 400;
                color: #d1d4dc;
                line-height: 21px;
              }

              .earnings-select {
                margin: 20px 32px 0 0;
                display: flex;
                justify-content: flex-end;

                .el-select {
                  margin-left: 20px;

                  .el-input {
                    .el-input__inner {
                      height: 32px !important;
                      background: transparent !important;
                      border: 1px solid rgba(209, 212, 220, 0.5);
                      border-radius: 4px !important;
                      color: #d1d4dc;
                    }

                    .el-input__inner.is-focus {
                      color: #d1d4dc;
                    }

                    .el-select__caret {
                      line-height: 32px;
                    }
                  }
                }
              }

              .statistics {
                width: 100%;
                height: 120px;
                background: rgba(255, 255, 255, 0.1);
                border-radius: 4px;
                display: flex;
                margin-top: 20px;

                .particulars-col {
                  width: 373px;
                  margin: 30px 0;
                  border-right: 1px solid rgba(255, 255, 255, 0.1);

                  .tittle {
                    margin: 0 0 0 120px;
                    font-size: 13px;
                    font-family: MicrosoftYaHei;
                    color: #d1d4dc;
                    line-height: 17px;
                  }

                  .price {
                    margin: 0 0 0 120px;
                    font-size: 24px;
                    font-family: DIN-Medium;
                    font-weight: 400;
                    color: #d1d4dc;
                    line-height: 42px;
                  }

                  .green {
                    margin: 0 0 0 120px;
                    font-size: 36px;
                    font-family: DIN-Medium;
                    font-weight: 400;
                    line-height: 42px;
                    color: rgba(0, 174, 147, 1);
                  }

                  .red {
                    margin: 0 0 0 120px;
                    font-size: 36px;
                    font-family: DIN-Medium;
                    font-weight: 400;
                    line-height: 42px;
                    color: rgba(247, 82, 95, 1);
                  }
                }
              }
            }

            .account-balance {
              margin-top: 32px;

              .account-tittle {
                font-size: 16px;
                font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                font-weight: 400;
                color: #d1d4dc;
                line-height: 21px;
              }

              .account-tab {
                font-size: 16px;
                font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                font-weight: 400;
                color: #d1d4dc;
                margin-top: 16px;

                .account {
                  .el-tabs__header {
                    margin: 0 !important;
                    padding: 0 !important;
                    border-bottom: none;

                    .el-tabs__nav-wrap {
                      .el-tabs__nav-scroll {
                        .el-tabs__nav {
                          width: 100%;
                          background: rgba(255, 255, 255, 0.1);
                          border: rgba(255, 255, 255, 0.1);
                          border-radius: 0;
                          display: flex;
                          justify-content: space-between;

                          .el-tabs__item {
                            width: 100%;
                            height: 48px !important;
                            text-align: center;
                            font-size: 16px;
                            font-family: MicrosoftYaHei;
                            color: #d1d4dc;
                            line-height: 48px;
                            border: none;
                            margin: 0 !important;
                          }

                          .el-tabs__item.is-active {
                            border-bottom-color: none;
                          }

                          .el-tabs__item:hover {
                            // color: rgba(51, 53, 62, 1);
                            background-color: #33353e !important;
                          }

                          .el-tabs__item.is-active {
                            color: rgba(51, 53, 62, 1);
                            background-color: rgba(237, 189, 136, 1) !important;
                          }
                        }
                      }
                    }
                  }

                  .el-tabs__content {
                    margin: 0 0 40px;

                    .el-tab-pane {
                      .el-table .ascending .sort-caret.ascending {
                        border-bottom-color: rgba(237, 189, 136, 1) !important;
                      }

                      .el-table .descending .sort-caret.descending {
                        border-top-color: rgba(237, 189, 136, 1) !important;
                      }

                      .current-Position {
                        .el-table__header-wrapper {
                          display: block !important;

                          .el-table__header {
                            .has-gutter {
                              tr {
                                height: 48px !important;

                                .el-table__cell {
                                  padding: 0 !important;

                                  .cell {
                                    height: 48px !important;
                                    line-height: 48px !important;
                                  }
                                }

                                .gutter {
                                  background: rgba(102,
                                      102,
                                      102,
                                      0.1) !important;
                                  border-bottom: none;
                                }
                              }
                            }
                          }
                        }

                        .el-table__body-wrapper {

                          //height: 336px !important;
                          .el-table__body tr:hover>td {
                            background: rgba(237, 189, 136, 1) !important;

                            .cell {
                              color: #33353e !important;
                              font-size: 14px;
                              font-family: Roboto-Regular, Roboto;
                              font-weight: 400;
                            }
                          }

                          .el-table__body {
                            tr {
                              height: 48px !important;

                              th {
                                .cell {
                                  .caret-wrapper {
                                    .sort-caret {
                                      border-top-color: rgba(237,
                                          189,
                                          136,
                                          1) !important;
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }

              .pagination {
                margin-top: 40px !important;
                text-align: center;

                .el-pagination.is-background .btn-next,
                .el-pagination.is-background .btn-prev,
                .el-pagination.is-background .el-pager li {
                  margin: 0 5px;
                  background-color: rgba(80, 82, 89, 1) !important;
                  color: #d1d4dc;
                  min-width: 32px;
                  min-height: 32px;
                  border-radius: 2px;
                }

                .el-pagination {
                  .el-pagination__sizes {
                    .el-select {
                      .el-input {
                        .el-input__inner {
                          height: 32px;
                          border: none !important;
                          background-color: rgba(80, 82, 89, 1) !important;
                          color: #d1d4dc;
                        }
                      }
                    }
                  }

                  .el-pager {
                    li {
                      padding: 4px 4px;
                    }
                  }

                  .el-pager li:not(.disabled):hover {
                    color: rgba(51, 53, 62, 1) !important;
                    background: #edbd88 !important;
                  }

                  .el-pager li:not(.disabled).active {
                    color: rgba(51, 53, 62, 1) !important;
                    background: #edbd88 !important;
                  }
                }
              }
            }
          }
        }
      }
    }

    .total-list-mm {
      margin: 32px 20px 24px;

      //background:none;
      .banner-tittle {
        display: flex;
        justify-content: space-between;

        .user {
          display: flex;

          //border-bottom: 1px solid rgba(0, 0, 0, 0.1);
          .user-img {
            // margin: 0px 0px 23px 0px;
            position: relative;

            .head-portrait {
              width: 82px;
              height: 82px;
              border-radius: 50%;
              border: 1px solid #ffffff;
            }

            .vip {
              width: 56px;
              height: 23px;
              position: absolute;
              top: 62px;
              right: 14px;
            }
          }

          .user-name {
            margin: 21px 0 0px 15px;
            display: flex;
            flex-direction: column;

            span {
              height: 21px;
              font-size: 18px;
              font-family: Roboto-Medium, Roboto;
              font-weight: 500;
              color: #d1d4dc;
              line-height: 21px;
            }

            .motto {
              margin-top: 4px;
              width: 100%;
              height: 18px;
              font-size: 13px;
              font-family: Roboto-Regular, Roboto;
              font-weight: 400;
              color: rgba(255, 255, 255, 0.7);
              line-height: 15px;
            }
          }
        }

        .user-btn {
          height: 100%;
          line-height: 88px;

          .el-button {
            padding: 6px 23px !important;
            background: transparent;
            border-radius: 4px;
            border: 1px solid rgba(255, 255, 255, 0.2);

            span {
              font-size: 14px;
              font-family: MicrosoftYaHei;
              color: #d1d4dc;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/User.vue